// Branded welcome — the hand-off from sign-up into onboarding (overhaul §6.2, panel 01).
// Renders as a .wiz-panel body (the rail shell is owned by OnboardingWizard).

export function WelcomeStep({ onNext }: { onNext: () => void }) {
  return (
    <>
      <div className="crumb">STEP 01 · DONE</div>
      <div className="wh">Signed in with <span className="em">Google</span>.</div>
      <p className="wp">
        You're in — no form, no password. Terum created your identity in seconds. (Invited
        users land here too, straight off the invite link.)
      </p>
      <div className="wiz-foot">
        <button className="btn btn-primary" onClick={onNext}>Continue <span className="arr">→</span></button>
        <span className="prog">Step 1 of 4</span>
      </div>
    </>
  );
}
